import {FC, useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {createPortal} from 'react-dom'
import classNames from 'classnames'
import {LoadingSpinner, RenderIf} from 'components'
import {Button} from 'design'
import {colorCodes} from 'definitions/constant'

interface CommonFooterProps {
  isVisible: boolean
  onCancel: () => void
  onSave: () => void
  isLoading?: boolean
  isBlueFooter?: boolean
  message?: string
}

export const CommonFooter: FC<CommonFooterProps> = ({
  isVisible,
  onCancel,
  onSave,
  isLoading = false,
  isBlueFooter = false,
  message = '',
}) => {
  const {t} = useTranslation(['common'])
  const footerMessage = message || t('SAVE_FOOTER_MESSAGE')
  const elementEle = useMemo(
    () => document.getElementById('main-layout') as Element,
    [],
  )

  return (
    <RenderIf isTrue={isVisible}>
      {createPortal(
        <div
          className={classNames(
            'mobile-common-footer h-14 w-full border-t-0.5 border-gray-400 flex justify-end items-center',
            {
              'bg-dope-teal-100': isBlueFooter,
              'bg-dope-black': !isBlueFooter,
            },
          )}
          aria-label={t('CANCEL_SAVE_FOOTER')}
        >
          <p
            aria-label="Footer message"
            className="text-white karla-bold text-sm mr-6"
            dangerouslySetInnerHTML={{
              __html: footerMessage,
            }}
          ></p>
          <Button
            className="mr-3"
            size="md"
            borderRadius="rounded"
            colorScheme={isBlueFooter ? 'cyan' : 'red'}
            onClick={onCancel}
            data-cy="footer-cancel-button"
            aria-label="Footer cancel button"
          >
            {t('CANCEL')}
          </Button>

          <Button
            size="sm"
            className="mr-6"
            borderRadius="rounded"
            onClick={onSave}
            disabled={isLoading}
            data-cy="footer-save-button"
            aria-label="Footer save button"
          >
            <RenderIf isTrue={!isLoading}>{t('SAVE')}</RenderIf>
            <RenderIf isTrue={isLoading}>
              <LoadingSpinner
                type="TailSpin"
                color={colorCodes.dopeBlack}
                width={16}
                height={16}
              />
            </RenderIf>
          </Button>
        </div>,
        elementEle,
      )}
    </RenderIf>
  )
}
